import { useEffect, useRef } from "react";

export default function WakeWordListener({ onWakeWordDetected }) {
    // const recognitionRef = useRef(null);
    // const restartTimeoutRef = useRef(null);
    // const isRestarting = useRef(false); // Prevent multiple restarts
    // const isSpeaking = useRef(false); // Prevent restarts while confirmation audio is playing

    // useEffect(() => {
    //     if (typeof window === "undefined") {
    //         console.error("❌ Wake Word Listener cannot run on server-side.");
    //         return;
    //     }

    //     if (!("webkitSpeechRecognition" in window)) {
    //         console.error("❌ Web Speech API is not supported in this browser.");
    //         return;
    //     }

    //     function startListening() {
    //         if (recognitionRef.current) {
    //             recognitionRef.current.stop(); // Ensure a clean start
    //         }

    //         console.log("🎤 Starting wake word detection...");

    //         recognitionRef.current = new window.webkitSpeechRecognition();
    //         const recognition = recognitionRef.current;

    //         recognition.continuous = true;
    //         recognition.interimResults = false; // ✅ Only process full phrases
    //         recognition.lang = "en-US";

    //         recognition.onstart = () => {
    //             console.log("🎤 Listening for wake word...");
    //             isRestarting.current = false; // Reset restart flag
    //         };

    //         recognition.onresult = (event) => {
    //             if (isSpeaking.current) return; // ✅ Prevent immediate restart during speaking
                
    //             const transcript = event.results[event.results.length - 1][0].transcript.toLowerCase().trim();
    //             console.log("🔊 Heard:", transcript);

    //             const possibleWakeWords = [
    //                 "hi saras 3d",
    //                 "hey saras 3d",
    //                 "hi sarah 3d",
    //                 "hey sarah 3d",
    //                 "hi sara three d",
    //                 "hey sara three d",
    //                 "hi saras d",
    //                 "hey saras d",
    //                 "hi aras 3",
    //                 "saraswati",
    //                 "saras 3d",
    //                 "saras"
    //             ];

    //             if (possibleWakeWords.some(phrase => transcript.includes(phrase))) {
    //                 console.log("✅ Wake word detected! Speaking confirmation...");
    //                 isSpeaking.current = true; // ✅ Prevent re-triggering during audio playback

    //                 // ✅ Speak "Please ask me anything."
    //                 const synth = window.speechSynthesis;
    //                 const utterance = new SpeechSynthesisUtterance("Please ask me anything.");
    //                 utterance.lang = "en-US";

    //                 utterance.onend = () => {
    //                     console.log("🎤 Prompt finished. Starting Whisper...");
    //                     isSpeaking.current = false; // ✅ Allow wake word detection again
    //                     onWakeWordDetected(); // 🔥 Trigger Whisper transcription **after audio finishes**
    //                     restartWithDelay(5000); // ✅ Restart wake word detection after 5s
    //                 };

    //                 synth.speak(utterance);
    //                 recognition.stop(); // ✅ Stop recognition while audio is playing
    //             }
    //         };

    //         recognition.onerror = (event) => {
    //             console.error("❌ Speech Recognition Error:", event.error);

    //             if (event.error === "no-speech" || event.error === "aborted") {
    //                 console.warn("⚠️ No speech detected. Retrying in 3 seconds...");
    //                 restartWithDelay(3000);
    //             } else {
    //                 console.warn("⚠️ Unexpected error. Restarting in 5 seconds...");
    //                 restartWithDelay(5000);
    //             }
    //         };

    //         recognition.onend = () => {
    //             if (!isSpeaking.current) {
    //                 console.warn("⚠️ Recognition ended, restarting...");
    //                 restartWithDelay(3000);
    //             }
    //         };

    //         recognition.start();
    //     }

    //     function restartWithDelay(delay) {
    //         if (isRestarting.current || isSpeaking.current) return; // Prevent unnecessary restarts
    //         isRestarting.current = true;

    //         clearTimeout(restartTimeoutRef.current);
    //         restartTimeoutRef.current = setTimeout(() => {
    //             console.log("🔄 Restarting wake word detection...");
    //             startListening();
    //         }, delay);
    //     }

    //     startListening(); // ✅ Start initially

    //     return () => {
    //         if (recognitionRef.current) {
    //             recognitionRef.current.stop();
    //         }
    //         clearTimeout(restartTimeoutRef.current);
    //     };
    // }, [onWakeWordDetected]);

    return null;
}
